import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {ErrorInterceptor} from '@iw-shop/core/classes/error-interceptor';
import {TokenInterceptor} from '@iw-shop/core/classes//token-interceptor';
import {OfflineInterceptor} from "@iw-shop/core/classes/offline-interceptor";

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
    {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: OfflineInterceptor, multi: true}
];
